import React, { useState } from "react";
import {
  TextField,
  Button,
  Box,
  FormControlLabel,
  Checkbox,
} from "@mui/material";
import { LocalizationProvider, DatePicker } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";

const Sede = ({ onSubmit }) => {
  const [formData, setFormData] = useState({
    nombre: "",
    accesos: "",
    equiposAdicionales: "",
    sai: false,
    domicilio: "",
    codigoPostal: "",
    poblacion: "",
    provincia: "",
    fechaAntiguedad: null,
  });

  const handleChange = (event) => {
    const { name, value, type, checked } = event.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleDateChange = (date) => {
    setFormData((prev) => ({
      ...prev,
      fechaAntiguedad: date ? dayjs(date).format("YYYY-MM") : "",
    }));
  };

  const handleSubmit = () => {
    onSubmit(formData);
  };

  return (
    <Box>
      <p style={{ fontSize: "13px", color: "gray", marginBottom: "10px" }}>
      Lugar habitual de trabajo (oficina, despacho, tienda, taller, gabinete, consulta…)
      </p>
      <TextField
        fullWidth
        label="Nombre (Ciudad donde está ubicada la sede)"
        name="nombre"
        value={formData.nombre}
        onChange={handleChange}
        margin="normal"
      />
      <TextField
        fullWidth
        label="Accesos"
        name="accesos"
        value={formData.accesos}
        onChange={handleChange}
        margin="normal"
        helperText="Puerta blindada o de seguridad, sistema de alarma, sistema de videovigilancia, rejas en algún acceso, guardia de seguridad, conserje, portero físico, videoportero, entre otros"
      />
      <TextField
        fullWidth
        label="Equipos adicionales (Caja fuerte, extintores, etc.…)"
        name="equiposAdicionales"
        value={formData.equiposAdicionales}
        onChange={handleChange}
        margin="normal"
      />
      <FormControlLabel
        control={
          <Checkbox name="sai" checked={formData.sai} onChange={handleChange} />
        }
        label="Sistema de Alimentación Ininterrumpida (SAI)"
      />
      <TextField
        fullWidth
        label="Domicilio"
        name="domicilio"
        value={formData.domicilio}
        onChange={handleChange}
        margin="normal"
      />
      <TextField
        fullWidth
        label="Código Postal (C.P.)"
        name="codigoPostal"
        value={formData.codigoPostal}
        onChange={handleChange}
        onInput={(e) => {
          e.target.value = e.target.value.replace(/\D/g, "").slice(0, 5);
        }}
        margin="normal"
      />
      <TextField
        fullWidth
        label="Población"
        name="poblacion"
        value={formData.poblacion}
        onChange={handleChange}
        margin="normal"
      />
      <TextField
        fullWidth
        label="Provincia"
        name="provincia"
        value={formData.provincia}
        onChange={handleChange}
        margin="normal"
      />

      {/* Date Picker para Fecha de Antigüedad */}
      <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="es">
        <DatePicker
          views={["year", "month"]}
          label="Fecha de antigüedad de la sede"
          value={
            formData.fechaAntiguedad ? dayjs(formData.fechaAntiguedad) : null
          } sx={{ width: "100%" }}
          onChange={handleDateChange}
          renderInput={(params) => (
            <TextField fullWidth margin="normal" {...params} />
          )}
        />
      </LocalizationProvider>

      <Button
        variant="contained"
        color="primary"
        fullWidth
        sx={{ mt: 2 }}
        onClick={handleSubmit}
      >
        Guardar Información
      </Button>
    </Box>
  );
};

export default Sede;
